export default "__VITE_ASSET__CF6ou4oy__"